import {useEffect, useRef} from "react";

import {useABTest} from "@pg-mono/ab-testing";
import {trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {
    PROPERTY_FAQ_ANONYMOUS_AB_TEST_ID,
    PROPERTY_FAQ_ANONYMOUS_BASE_VARIANT,
    PROPERTY_FAQ_ANONYMOUS_GATED_VARIANT,
    PROPERTY_FAQ_ANONYMOUS_OPEN_VARIANT,
    PROPERTY_FAQ_LOGGED_IN_AB_TEST_ID,
    PROPERTY_FAQ_LOGGED_IN_BASE_VARIANT,
    PROPERTY_FAQ_LOGGED_IN_OPEN_VARIANT
} from "../../ab_testing/property_faq_ab_tests";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";

interface IPropertyFaqExperiment {
    /** The applicable test has not assigned a variant yet — the FAQ renders a placeholder */
    isResolved: boolean;
    /** The assigned variant renders the FAQ section (every variant but the base one) */
    isFaqEnabled: boolean;
    /** The assigned variant serves the answers without the registration gate */
    isAnswerGateDisabled: boolean;
    variant: string | null;
}

const OPEN_VARIANTS: string[] = [PROPERTY_FAQ_LOGGED_IN_OPEN_VARIANT, PROPERTY_FAQ_ANONYMOUS_OPEN_VARIANT];
const FAQ_VARIANTS: string[] = [...OPEN_VARIANTS, PROPERTY_FAQ_ANONYMOUS_GATED_VARIANT];
const BASE_VARIANTS: string[] = [PROPERTY_FAQ_LOGGED_IN_BASE_VARIANT, PROPERTY_FAQ_ANONYMOUS_BASE_VARIANT];

export const usePropertyFaqExperiment = (): IPropertyFaqExperiment => {
    const {data: isAuthenticated, isSuccess, isError} = useGetIsUserAuthenticatedQuery();
    // Until the auth state is known we cannot tell which of the two tests applies, so neither is reported
    const isAuthResolved = isSuccess || isError;
    const isLoggedInTestApplicable = isAuthResolved && !!isAuthenticated;

    // Both tests are read on every render — Amplitude assigns a variant per device regardless of the auth state,
    // and the exposure below is what marks the test the user actually took part in
    const loggedInTest = useABTest({
        id: PROPERTY_FAQ_LOGGED_IN_AB_TEST_ID,
        variants: [PROPERTY_FAQ_LOGGED_IN_BASE_VARIANT, PROPERTY_FAQ_LOGGED_IN_OPEN_VARIANT],
        pushEventOnlyOnce: true
    });

    const anonymousTest = useABTest({
        id: PROPERTY_FAQ_ANONYMOUS_AB_TEST_ID,
        variants: [PROPERTY_FAQ_ANONYMOUS_BASE_VARIANT, PROPERTY_FAQ_ANONYMOUS_OPEN_VARIANT, PROPERTY_FAQ_ANONYMOUS_GATED_VARIANT],
        pushEventOnlyOnce: true
    });

    const applicableTest = isLoggedInTestApplicable ? loggedInTest : anonymousTest;
    const applicableTestId = isLoggedInTestApplicable ? PROPERTY_FAQ_LOGGED_IN_AB_TEST_ID : PROPERTY_FAQ_ANONYMOUS_AB_TEST_ID;
    const variant = typeof applicableTest.abTestVariant === "string" ? applicableTest.abTestVariant : null;
    const hasAssignedVariant =
        isAuthResolved && applicableTest.canABTestBeRendered && !!variant && (FAQ_VARIANTS.includes(variant) || BASE_VARIANTS.includes(variant));

    const hasTrackedExposureRef = useRef(false);

    useEffect(() => {
        if (!hasAssignedVariant || hasTrackedExposureRef.current) {
            return;
        }

        hasTrackedExposureRef.current = true;

        void waitForAmplitudeInitialization()
            .catch(() => undefined)
            .finally(() => trackAmplitudeExperimentExposure(applicableTestId));
    }, [hasAssignedVariant, applicableTestId]);

    return {
        isResolved: hasAssignedVariant,
        isFaqEnabled: hasAssignedVariant && FAQ_VARIANTS.includes(variant as string),
        isAnswerGateDisabled: hasAssignedVariant && OPEN_VARIANTS.includes(variant as string),
        variant: hasAssignedVariant ? variant : null
    };
};
import {useEffect, useRef} from "react";

import {useABTest} from "@pg-mono/ab-testing";
import {trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {
    PROPERTY_FAQ_ANONYMOUS_AB_TEST_ID,
    PROPERTY_FAQ_ANONYMOUS_BASE_VARIANT,
    PROPERTY_FAQ_ANONYMOUS_GATED_VARIANT,
    PROPERTY_FAQ_ANONYMOUS_OPEN_VARIANT,
    PROPERTY_FAQ_LOGGED_IN_AB_TEST_ID,
    PROPERTY_FAQ_LOGGED_IN_BASE_VARIANT,
    PROPERTY_FAQ_LOGGED_IN_OPEN_VARIANT
} from "../../ab_testing/property_faq_ab_tests";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";

interface IPropertyFaqExperiment {
    /** The applicable test has not assigned a variant yet — the FAQ renders a placeholder */
    isResolved: boolean;
    /** The assigned variant renders the FAQ section (every variant but the base one) */
    isFaqEnabled: boolean;
    /** The assigned variant serves the answers without the registration gate */
    isAnswerGateDisabled: boolean;
    variant: string | null;
}

const OPEN_VARIANTS: string[] = [PROPERTY_FAQ_LOGGED_IN_OPEN_VARIANT, PROPERTY_FAQ_ANONYMOUS_OPEN_VARIANT];
const FAQ_VARIANTS: string[] = [...OPEN_VARIANTS, PROPERTY_FAQ_ANONYMOUS_GATED_VARIANT];
const BASE_VARIANTS: string[] = [PROPERTY_FAQ_LOGGED_IN_BASE_VARIANT, PROPERTY_FAQ_ANONYMOUS_BASE_VARIANT];

export const usePropertyFaqExperiment = (): IPropertyFaqExperiment => {
    const {data: isAuthenticated, isSuccess, isError} = useGetIsUserAuthenticatedQuery();
    // Until the auth state is known we cannot tell which of the two tests applies, so neither is reported
    const isAuthResolved = isSuccess || isError;
    const isLoggedInTestApplicable = isAuthResolved && !!isAuthenticated;

    // Both tests are read on every render — Amplitude assigns a variant per device regardless of the auth state,
    // and the exposure below is what marks the test the user actually took part in
    const loggedInTest = useABTest({
        id: PROPERTY_FAQ_LOGGED_IN_AB_TEST_ID,
        variants: [PROPERTY_FAQ_LOGGED_IN_BASE_VARIANT, PROPERTY_FAQ_LOGGED_IN_OPEN_VARIANT],
        pushEventOnlyOnce: true
    });

    const anonymousTest = useABTest({
        id: PROPERTY_FAQ_ANONYMOUS_AB_TEST_ID,
        variants: [PROPERTY_FAQ_ANONYMOUS_BASE_VARIANT, PROPERTY_FAQ_ANONYMOUS_OPEN_VARIANT, PROPERTY_FAQ_ANONYMOUS_GATED_VARIANT],
        pushEventOnlyOnce: true
    });

    const applicableTest = isLoggedInTestApplicable ? loggedInTest : anonymousTest;
    const applicableTestId = isLoggedInTestApplicable ? PROPERTY_FAQ_LOGGED_IN_AB_TEST_ID : PROPERTY_FAQ_ANONYMOUS_AB_TEST_ID;
    const variant = typeof applicableTest.abTestVariant === "string" ? applicableTest.abTestVariant : null;
    const hasAssignedVariant =
        isAuthResolved && applicableTest.canABTestBeRendered && !!variant && (FAQ_VARIANTS.includes(variant) || BASE_VARIANTS.includes(variant));

    const hasTrackedExposureRef = useRef(false);

    useEffect(() => {
        if (!hasAssignedVariant || hasTrackedExposureRef.current) {
            return;
        }

        hasTrackedExposureRef.current = true;

        void waitForAmplitudeInitialization()
            .catch(() => undefined)
            .finally(() => trackAmplitudeExperimentExposure(applicableTestId));
    }, [hasAssignedVariant, applicableTestId]);

    return {
        isResolved: hasAssignedVariant,
        isFaqEnabled: hasAssignedVariant && FAQ_VARIANTS.includes(variant as string),
        isAnswerGateDisabled: hasAssignedVariant && OPEN_VARIANTS.includes(variant as string),
        variant: hasAssignedVariant ? variant : null
    };
};
